import { defineStyle, defineStyleConfig } from '@chakra-ui/react'
import { mode, transparentize } from '@chakra-ui/theme-tools'
import { textStyles } from '../foundations/textStyles'

export const baseStyle = defineStyle(props => {
  const { textStyle } = props
  if (textStyle === 'eyebrow') {
    return {
      ...textStyles['eyebrow'],
      borderRadius: 4,
      border: '1px solid',
    }
  } else {
    return {
      fontWeight: 'regular',
      textTransform: 'none;',
      borderRadius: 4,
      border: '1px solid',
    }
  }
})

export const variantSolid = defineStyle(props => {
  const { colorScheme } = props

  return {
    bg: `${colorScheme}.500`,
    color: mode(`white`, `black`)(props),
    border: '1px solid',
    borderColor: `${colorScheme}.600`,
  }
})

export const variantOutline = defineStyle(props => {
  const { colorScheme } = props
  return {
    bg: 'transparent',
    border: '1px solid',
    color: `${colorScheme}.500`,
    borderColor: `${colorScheme}.500`,
    '.chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)':
      { marginEnd: '-1px' },
    '.chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)':
      { marginBottom: '-1px' },
  }
})

export const variantSubtle = defineStyle(props => {
  const { colorScheme, theme } = props

  const darkBg = transparentize(`${colorScheme}.600`, 0.12)(theme)

  return {
    bg: mode(`${colorScheme}.100`, darkBg)(props),
    color: mode(`${colorScheme}.800`, `${colorScheme}.900`)(props),
    borderColor: mode(`${colorScheme}.100`, darkBg)(props),
  }
})

export const variants = {
  solid: variantSolid,
  outline: variantOutline,
  subtle: variantSubtle,
}

export const sizes = {
  sm: defineStyle({
    ...textStyles.sm,
  }),
  md: defineStyle({
    ...textStyles.md,
  }),
  lg: defineStyle({
    ...textStyles.lg,
  }),
}

export const Badge = defineStyleConfig({
  baseStyle,
  variants,
  sizes,
  defaultProps: {
    variant: 'solid',
    colorScheme: 'neutral',
    size: 'md',
  },
})
